const STORAGE_KEY = "qf_pending_attempts";
const TTL_MS = 48 * 60 * 60 * 1000; // 48 hours — matches server-side token TTL

export function savePendingAttempt(quizSlug, attemptToken, pointsWouldEarn) {
  const existing = _readRaw();
  // Deduplicate by quiz slug — keep the latest attempt per quiz
  const filtered = existing.filter((a) => a.quiz_slug !== quizSlug);
  filtered.push({
    quiz_slug: quizSlug,
    attempt_token: attemptToken,
    points_would_earn: pointsWouldEarn,
    saved_at: Date.now(),
  });
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  } catch (_) {
    // localStorage full or unavailable — skip silently
  }
}

export function getPendingAttempts() {
  const now = Date.now();
  return _readRaw().filter((a) => now - a.saved_at < TTL_MS);
}

export function clearPendingAttempts() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_) {}
}

function _readRaw() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch (_) {
    return [];
  }
}
